import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Range } from '../../../../features/card-editor/components/range/range';
import { usePhotoControls } from '../../../../features/card-editor/hooks/use-photo-controls';
import { HeaderContentProps } from '../rotate-drawer-types';
import { getComputedRotation } from '../rotate-drawer-utils';
import styles from '../rotate-drawer.module.scss';
import { Text } from '@dotcom/crown-ui';

export const HeaderContent = ({ onChangeCallback, initialValue }: HeaderContentProps): React.ReactElement => {
  const rangeName = 'RotateRange';
  const { rotateSelectedPhoto } = usePhotoControls();
  const { register, setValue, watch } = useForm({
    defaultValues: {
      [rangeName]: getComputedRotation(initialValue),
    },
  });
  const rangeValue = watch(rangeName);
  const { t } = useTranslation();

  useEffect(() => {
    setValue(rangeName, getComputedRotation(initialValue));
  }, [initialValue, setValue, rangeName]);

  const onChange = (valueInRange: number) => {
    rotateSelectedPhoto(Number(valueInRange));
    if (onChangeCallback) {
      onChangeCallback();
    }
  };

  return (
    <div className={styles['header-wrapper']}>
      <div className={styles['rotation-label']}>
        <Text as="label">{t('rotateDrawer.left')}</Text>
        <Text as="span" color="textPrimary" className={styles['value']}>
          {`${Math.round(rangeValue)}`}
        </Text>
        <Text as="label">{t('rotateDrawer.right')}</Text>
      </div>
      <Range
        domId={'drawer-range'}
        label={'Rotate'}
        min={-180}
        max={180}
        step={1}
        showValueInLabel={true}
        testId="rotate-drawer--range"
        tickCount={9}
        onChange={onChange}
        register={register(rangeName)}
      />
    </div>
  );
};
